import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { DropdownMenu } from "reactstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getDashboard } from "../../../api/orders";
const EmployerUserDropdown = ({ onLogout, toggleUserDropdown }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [planName, setPlanName] = useState("");
  const [isPlanActive, setIsPlanActive] = useState(true);

  useEffect(() => {
    getDashboard()
      .then((res) => {
        const data = res?.data?.data;
        setPlanName(data?.planName || "");
        setIsPlanActive(Boolean(data?.isPlanActive));
      })
      .catch((err) => {
        console.error("Error fetching dashboard data:", err);
      });
  }, []);

  const handleLogoutClick = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout from your account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // 1. Clear everything from storage
        localStorage.removeItem("webvi_authToken");
        localStorage.removeItem("jobseekerspage_userId");
        localStorage.removeItem("webvi_userInfo");
        localStorage.removeItem("jobseekerspage_redirect_url");

        // 2. Call the logout function to clear Redux
        onLogout();

        // 3. Instead of navigate("/"), use this to force the UI to reset
        window.location.href = "/";
      }
    });
  };

  const activeClass = (url) => (pathname === url ? "active" : "");
  const dropdownData = [
    {
      id: 1,
      name: "Dashboard",
      url: "/employer/dashboard",
    },
    {
      id: 2,
      name: "Search Candidates",
      url: "/candidates",
    },
    {
      id: 3,
      name: "Manage Job Applications",
      url: "/employer/job/application/manage",
    },
    {
      id: 4,
      name: "Bookmarked Candidates",
      url: "/employer/bookmark-candidates",
    },
    {
      id: 5,
      name: " Post & Manage Jobs",
      url: "/employer/job/manage",
    },
    {
      id: 6,
      name: "Manage Company",
      url: "/employer/company/manage",
    },
    {
      id: 9,
      name: "Unlocked Candidates",
      url: "/employer/purchased-candidates",
    },
    {
      id: 7,
      name: "Credits & History",
      url: "/employer/orders",
    },
    {
      id: 10,
      name: "Bill History (Invoice↓)",
      url: "/employer/bill-history",
    },
    {
      id: 8,
      name: "My Profile",
      url: "/employer/profile",
    },
  ];

  // 🎯 hide "Search Candidates" only when plan is "free" AND inactive
  // 🎯 hide "Search Candidates" if the plan is "Free" OR inactive — either
  // condition alone is enough to hide it, not just both together.
  const visibleDropdownData = dropdownData.filter((item) => {
    if (item.id === 2) {
      return !(planName?.toLowerCase() === "free" || isPlanActive === false);
    }
    return true;
  });

  return (
    <DropdownMenu
      className="dropdown-menu-end cust-dropdown"
      aria-labelledby="userdropdown"
      end
    >
      {visibleDropdownData?.map((item) => (
        <li key={`emp-dropdown-item-${item?.id}`}>
          <Link
            className={`dropdown-item ${activeClass(item?.url)}`}
            onClick={toggleUserDropdown}
            to={item?.url}
          >
            {item?.name}
          </Link>
        </li>
      ))}

      <li>
        <Link className={`dropdown-item`} onClick={handleLogoutClick}>
          Logout
        </Link>
      </li>
    </DropdownMenu>
  );
};

export default EmployerUserDropdown;